module.exports = "<ad-layout-ui-loader></ad-layout-ui-loader>\r\n<router-outlet></router-outlet>\r\n"